module.exports = __webpack_public_path__ + "static/media/qa.b39ab9d6.svg";